var _defs, _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "27440cf584"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.640625 27.675781 L 135.359375 27.675781 L 135.359375 131.167969 L 14.640625 131.167969 Z M 14.640625 27.675781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "917f7e7edc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102 18.667969 L 111 18.667969 L 111 41 L 102 41 Z M 102 18.667969 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8b9a7b",
    d: "M 49.984375 31.808594 L 99.289062 31.808594 C 99.746094 31.808594 100.113281 31.441406 100.113281 30.984375 L 100.113281 28.511719 C 100.113281 28.054688 99.746094 27.6875 99.289062 27.6875 L 49.984375 27.6875 C 49.53125 27.6875 49.160156 28.054688 49.160156 28.511719 L 49.160156 30.984375 C 49.160156 31.441406 49.53125 31.808594 49.984375 31.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#27440cf584)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8b9a7b",
    d: "M 122.523438 127.210938 L 27.476562 127.210938 C 22.664062 127.210938 18.761719 123.308594 18.761719 118.496094 L 18.761719 60.484375 L 131.238281 60.484375 L 131.238281 118.496094 C 131.238281 123.308594 127.335938 127.210938 122.523438 127.210938 Z M 122.523438 27.6875 L 113.304688 27.6875 C 112.851562 27.6875 112.480469 28.054688 112.480469 28.511719 L 112.480469 30.984375 C 112.480469 31.4375 112.851562 31.808594 113.304688 31.808594 L 122.523438 31.808594 C 127.332031 31.808594 131.238281 35.714844 131.238281 40.53125 L 131.238281 56.363281 L 18.761719 56.363281 L 18.761719 40.53125 C 18.761719 35.714844 22.671875 31.808594 27.476562 31.808594 L 35.96875 31.808594 C 36.425781 31.808594 36.792969 31.4375 36.792969 30.984375 L 36.792969 28.511719 C 36.792969 28.054688 36.425781 27.6875 35.96875 27.6875 L 27.476562 27.6875 C 20.402344 27.6875 14.640625 33.449219 14.640625 40.53125 L 14.640625 118.496094 C 14.640625 125.554688 20.417969 131.332031 27.476562 131.332031 L 122.523438 131.332031 C 129.585938 131.332031 135.359375 125.554688 135.359375 118.496094 L 135.359375 40.53125 C 135.359375 33.449219 129.597656 27.6875 122.523438 27.6875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b9a7b",
    d: "M 42.976562 41.84375 C 45.023438 41.84375 46.6875 40.183594 46.6875 38.132812 L 46.6875 23.398438 C 46.6875 21.347656 45.023438 19.6875 42.976562 19.6875 C 40.925781 19.6875 39.265625 21.347656 39.265625 23.398438 L 39.265625 38.132812 C 39.265625 40.183594 40.925781 41.84375 42.976562 41.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#917f7e7edc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8b9a7b",
    d: "M 106.296875 40.828125 C 108.34375 40.828125 110.007812 39.164062 110.007812 37.117188 L 110.007812 22.375 C 110.007812 20.332031 108.34375 18.667969 106.296875 18.667969 C 104.246094 18.667969 102.589844 20.332031 102.589844 22.375 L 102.589844 37.117188 C 102.589844 39.164062 104.246094 40.828125 106.296875 40.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.edc2083a56f987210ac7eb9b11f3f85b.svg";
export { ForwardRef as ReactComponent };